export default {
  title_change_unlock_key: "Change Unlock Key",
  input_current_password: "Current password",
  input_unlock_key: "Unlock Key",
  msg_unlock_key_changed: "Unlock key changed",
}
